(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Matches
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('Invoicesgroup', Invoicesgroup);

  function Invoicesgroup($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/invoicesgroup/:id', {id: '@_id'}, {
    
      query: {
        method: 'GET',
        isArray: true
    }
  });
}}());


